import { useMemo } from 'react';

import { createAxiosInstance } from '@kc-console/core';

import type { AxiosInstance } from 'axios';

import { useRegionEndpoint } from '@/shared/hooks';

/**
 * Status Board 퍼블릭 API용 axios 인스턴스를 생성한다.
 * @description
 * - 인증 토큰이 필요 없는 퍼블릭 서비스이므로 baseURL만 주입한다.
 * - 현재 리전 엔드포인트(public)를 baseURL로 사용한다.
 * - `overrideOnFulfilled`로 기본 인터셉터를 비활성화하여 `AxiosResponse` 구조를 그대로 유지한다.
 * @example
 * const { instance } = useStatusBoardApi();
 * const response = await instance.get('/api/console/service-status');
 */
export const useStatusBoardApi = (): { instance: AxiosInstance } => {
  const { currentRegionEndpointInfo } = useRegionEndpoint();
  const baseURL = currentRegionEndpointInfo?.public ?? '';

  const instance = useMemo(
    () =>
      createAxiosInstance({
        baseURL,
        overrideOnFulfilled: response => response,
      }),
    [baseURL],
  );

  return { instance };
};
